import { createAsyncThunk } from '@reduxjs/toolkit'
import { AdminState } from 'admin/services/state'
import { Action, Dispatch, MiddlewareAPI } from 'redux'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { Observable } from 'rxjs'
import AuthState from 'services/auth/state'
import ComposerState from 'services/compose/state'
import ContentState from 'services/content/state'
import { ContentPopupState } from 'services/contentPopup'
import { ContentPreviewState } from 'services/contentPreview'
import PostDestinationsState from 'services/destinations/state'
import { ExternalServicesState } from 'services/external'
import ListsState from 'services/lists'
import PlanState from 'services/plan/state'
import PostState from 'services/post/state'
import { ProductState } from 'services/product/state'
import SearchState from 'services/search/state'
import SettingsState from 'services/settings/state'
import SnackbarState from 'services/snackbar/state'
import { AppUIState } from 'services/ui/state'
import UploadsState from 'services/uploads/state'
import { UserState } from 'services/users'

export type { Action }
export type AnyAction = { type: string, payload?: any }

export type StoreThunkAction<R> = ThunkAction<R, StoreState, void, AnyAction>
export type StoreThunkDispatch = ThunkDispatch<StoreState, void, AnyAction>
export const createAppAsyncThunk = createAsyncThunk.withTypes<{ state: StoreState; dispatch: StoreThunkDispatch }>()
export type StoreMiddlewareApi = MiddlewareAPI<StoreState & StoreDispatch>
export type StoreDispatch = Dispatch<AnyAction>
export type StoreObservable<R> = Observable<StoreThunkAction<R>|Action>

export type getState = () => StoreState
export type StoreState = object & {
  content: ContentState
  composer: ComposerState
  destinations: PostDestinationsState
  lists: ListsState
  snackbar: SnackbarState
  user: UserState
  product: ProductState
  plan: PlanState
  post: PostState
  contentPreview: ContentPreviewState
  admin: AdminState
  external: ExternalServicesState
  auth: AuthState
  settings: SettingsState
  contentPopup: ContentPopupState
  uploads: UploadsState
  search: SearchState
  hydration: boolean
  version: { [key: string]: string }
  ui: AppUIState
}

export default StoreState
